angular.module('eStories.account', [
    /*eStories Account*/
    'eStories.account.overview',
    'eStories.device.model'

])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.account', {
                url: 'account',
                views: {
                    'mainView@': {
                        templateUrl: 'account/account.tmpl.html',
                        controller: 'AbstractAccountCtrl'
                    }
                }
            });
    }])

    .controller('AbstractAccountCtrl', ['$state', '$location', function ($state, $location) {
        //This controller is only used to redirect abstract state 'account' to 'account.overview'
        if ($state.current.name === 'eStories.navbars.account') {
            $location.path('account/overview');
        }
    }])

    .controller('UserDetailsModalCtrl', [function () {
    }])

    .controller('AccountCtrl', [
        'AccountModel',
        'BillingModel',
        'DeviceModel',
        'ModalsModel',
        'SeoModel',
        '$state',
        '$stateParams',
        'PagingModel',
        'LL',
        'PromoModel',
        '$location',
        'GA',
        function (AccountModel, BillingModel, DeviceModel, ModalsModel, SeoModel, $state, $stateParams,
                  PagingModel, LL, PromoModel, $location, GA) {

            SeoModel.applyMetaTags($state.current.name);

            PagingModel.resetPagingData();

            var accountCtrl = this;

            GA.trackPageView($location.path());

            if (isMobile.iOS()) {
                document.location.href = 'estoriesapp://account';
            }


            AccountModel.resetPlanPurchaseProperties();
            AccountModel.refreshSubscriptionDetails();
            accountCtrl.editUserDetails = function () {
                ModalsModel.open('editUserDetailsModal', 'UserDetailsModalCtrl', 'userDetailsModalCtrl');
            };

            accountCtrl.isMobileDevice = function () {
                return isMobile.any();
            };

            accountCtrl.shouldShowCrossedOutPlanPrice = function () {
                return AccountModel.hasPromoPlan() && AccountModel.subscriptionDetails.promoPackage.name !== "HALF_OFF_ANNUAL" && AccountModel.subscriptionDetails.subscription.planId !== 333006001;
            };

            accountCtrl.shouldShowDiscountedPlanPrice = function () {
                return AccountModel.hasPromoPlan() && AccountModel.subscriptionDetails.promoPackage.name !== "HALF_OFF_ANNUAL";
            };

            accountCtrl.getCreditCardIconClass = function () {
                if (AccountModel.savedPaymentDetails == null) {
                    return;
                }
                const cardType = AccountModel.savedPaymentDetails.creditCardDetails.cardType;
                return BillingModel.getCreditCardIconClass(cardType);
            };

            accountCtrl.removeDeviceFromDeviceList = function (deviceId) {
                var deviceList = accountCtrl.deviceList;
                for (var i = 0; i < deviceList.length; i++) {
                    if (deviceList[i].deviceId === deviceId) {
                        deviceList.splice(i, 1);
                        break;
                    }
                }
            };

            accountCtrl.disconnectDevice = async function (deviceId) {
                const response = await DeviceModel.disconnectDevice(deviceId);
                if (response.responseStatus === 'SUCCESS') {
                    accountCtrl.removeDeviceFromDeviceList(deviceId);
                }
            };

            accountCtrl.getDeviceColor = function (index) {
                var grey = index / 2 % 2 < 1;
                return grey ? 'grey' : '';
            };

            DeviceModel.getDeviceList().then(response => {
                accountCtrl.deviceList = response.deviceList;
            });

            accountCtrl.getDeviceIcon = function (platform) {
                return DeviceModel.getDeviceIcon(platform);
            };

            accountCtrl.getDeviceType = function (deviceType) {
                return DeviceModel.getDeviceType(deviceType);
            };

            accountCtrl.getDevicePlatform = function (platform) {
                return DeviceModel.getDevicePlatform(platform);
            };

            accountCtrl.getStringDate = function (date) {
                return getFullDate(date);
            };

            accountCtrl.tagLLEventReactivateHoldAccount = function (responseStatus) {
                var lltagObj = {};
                lltagObj['Current Plan'] = AccountModel.subscriptionDetails.subscription.plan.name;
                lltagObj['Current Plan Period'] = AccountModel.subscriptionDetails.subscription.plan.family;
                // lltagObj['Hold Period'] = holdCtrl.holdDuration;
                lltagObj['Success'] = responseStatus === 'SUCCESS' ? 'yes' : 'no';
                LL.tagEvent('Reactivate Hold', lltagObj)
            };

            accountCtrl.reactivateSubscription = async function () {
                const response = await AccountModel.unfreezeMembership();
                if (response && response.responseStatus === 'SUCCESS') {
                    accountCtrl.tagLLEventReactivateHoldAccount(response.responseStatus);
                    AccountModel.refreshSubscriptionDetails(function () {
                        ModalsModel.open('/plans/accountReactivationModal.tmpl.html', 'HoldCtrl', 'holdCtrl');
                    });
                }
            };

            accountCtrl.openResubscribeModal = function () {
                ModalsModel.open('/plans/resubscribeModal.tmpl.html', 'CancelPlanCtrl', 'cancelPlanCtrl');
            };

            accountCtrl.openUploadModal = function () {
                LL.tagEvent("Upload Select");
                ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl');
            };

            if ($state.current.name === 'eStories.navbars.account.cancel') {
                ModalsModel.open("/plans/cancelPlanModal.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
            }

            if ($state.current.name === 'eStories.navbars.account.upload') {
                AccountModel.refreshUserDetails(function () {
                    if (AccountModel.userDetails) {
                        LL.tagEvent("Upload Select");
                        ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl');
                    }
                });
            }

            if ($state.current.name === 'eStories.navbars.account.extraCredits') {
                AccountModel.refreshSubscriptionDetails(function () {
                    if (AccountModel.areExtraBoostersAllowed()) {
//                        get info about booster from server
                        PromoModel.searchPromoParams();
//                      check if PromoModel.promoPackage.planId == 333100000
                        if (AccountModel.savedPaymentDetails == null) {
                            AccountModel.refreshSavedPaymentDetails(function () {
                                AccountModel.showPurchaseAudiobookModal(null, 'BOOSTER');
                            });
                        } else {
                            AccountModel.showPurchaseAudiobookModal(null, 'BOOSTER');

                        }
                    }
                });
                $state.go('eStories.navbars.account.overview');
            }
//          this state is the base state for the deeplinked urls to pull up a change plan modal
            if ($state.current.name === 'eStories.navbars.account.updatePlan') {
                BillingModel.getAllPlans(function () {
                    var urlPlanId = $stateParams.planId;
                    for (var familyIndex in BillingModel.allPlanMap) {
                        var currentFamilyPlanList = BillingModel.allPlanMap[familyIndex];
                        for (var currentPlanIndex in currentFamilyPlanList) {
                            if (currentFamilyPlanList[currentPlanIndex].planId === urlPlanId) {
//                                      check if user has subscription
                                if (AccountModel.isPaidMember()) {
//                                      check if user is trying to switch to a plan they're currently on already
                                    if (urlPlanId === AccountModel.subscriptionDetails.subscription.plan.planId) {
                                        return;
                                    }
                                }

                                if (PromoModel.hasPlanPromo() || PromoModel.hasCreditPromo()) {
                                    AccountModel.setPendingPlanPurchaseType('PROMO');
                                }
                                AccountModel.setChosenPlan(currentFamilyPlanList[currentPlanIndex]);
                                AccountModel.showUpdatePaymentDetailsModal(false);
                            }
                        }
                    }
                });
            }
        }]);
